import { registry } from "src/app/enum"

export enum ClientsListViewType {
    All = 0,
    Owned = 1,
    Retailers = 2,
    Partners = 3
}
(ClientsListViewType as any).__typeName = 'ClientsListViewType';
registry[(<any>ClientsListViewType).__typeName] = ClientsListViewType;